import angular from 'angular';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';

angular
  .module('cxSettings')
  .controller('CopyTaskPeriodicityDialogCtrl', [
    '$element',
    '$scope',
    '$http',
    'appUrls',
    'flySvc',
    'close',
    'schedule',
    copyTaskPeriodicityDialogCtrl,
  ]);

function copyTaskPeriodicityDialogCtrl($element, $scope, $http, appUrls, flySvc, close, schedule) {
  var vm = this;
  vm.showValidation = false;
  vm.translation = {};
  vm.name = schedule.name;
  vm.schedule = angular.extend({}, schedule);

  vm.updateName = function(value) {
    vm.name = value;
  };

  vm.save = function() {
    if ($scope.form.$invalid) return;
    if (vm.translation && !vm.translation.isValid(true)) return;
    vm.saving = true;
    $http
      .post(`${appUrls.tasks}/api/TaskPeriodicity/copy/${vm.schedule.id}`, null, {
        params: { name: vm.name },
      })
      .then(
        function({ data = {} }) {
          vm.saving = false;
          if (data && data.id && vm.translation && vm.translation.save) {
            return vm.translation.save(data.id).then(function() {
              $element.modal('hide');
              close(data, 500);
              flySvc.success();
              return false;
            });
          } else {
            $element.modal('hide');
            close(data, 500);
            flySvc.success();
            return false;
          }
        },
        function(error) {
          vm.saving = false;
          flySvc.error(error);
        },
      );
  };

  vm.showValidationErrors = function() {
    vm.showValidation = true;
    if (vm.translation && vm.translation.isValid) vm.translation.isValid(true);
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
